// extracted by mini-css-extract-plugin
module.exports = {"icon":"KeyboardShortcut_icon__iFTja","shortcut":"KeyboardShortcut_shortcut__1Z-r7"};